import { PageHeader } from '@/components/layout/page-header';
import { FeeRunsPanel } from '@/features/fee-runs/fee-runs-panel';

const FeeRunsPage = () => (
  <div className="flex w-full flex-col gap-4">
    <PageHeader
      description="Monthly custody (OTE) and platform (OTM) fee collection, run on their fixed days. Calculate a run for the charge date, review who is charged what, then approve it to collect."
      documentTitle="Fee Collection - Bespoke Ops Portal - One Trading"
      title="Fee Collection"
    />
    <FeeRunsPanel />
  </div>
);
FeeRunsPage.displayName = 'FeeRunsPage';

export default FeeRunsPage;
